import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import translations from './translations/translations.json'
import { createI18n } from 'vue-i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueTelInput from 'vue-tel-input'
import { faFile, faFilePdf, faFileExcel, faFileWord, faFilePowerpoint, faFileImage, faFileArchive, faDownload, faPaperclip } from '@fortawesome/free-solid-svg-icons'

library.add(faFile, faFilePdf, faFileExcel, faFileWord, faFilePowerpoint, faFileImage, faFileArchive, faDownload, faPaperclip)

const i18n = createI18n({
  locale: 'en',
  messages: translations
})

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(i18n)

app.use(VueTelInput)

app.component('font-awesome-icon', FontAwesomeIcon)

app.directive('click-outside', {
  mounted (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event, el)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

app.mount('#chatAppContainer')
